import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAccountFlags } from '../../services/auth';
import { getOrders } from '../../services/orders';
import './AnalysisOrders.css';

const MAX_VISIBLE = 5;

const formatDate = (value) => (value ? new Date(value).toLocaleDateString('es-ES') : '—');
const formatHours = (hours) => (hours > 0 ? `${hours.toFixed(2).replace('.', ',')} h` : '—');

/** LAKPED-11: cierra el círculo plano → pedido. Solo pide datos si la cuenta
 *  tiene el módulo; en el resto no hace ni una llamada.
 *  LAKPED-5: desde aquí se presupuesta el plano, que es donde empieza el ciclo. */
const AnalysisOrders = ({ analysisHash }) => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!analysisHash) return undefined;

    const load = async () => {
      try {
        const account = await fetchAccountFlags();
        if (cancelled || !account.orders_enabled) return;
        setEnabled(true);
        const data = await getOrders({ analysis_hash: analysisHash, limit: 50 });
        if (cancelled) return;
        setOrders(data.orders || []);
      } catch (error) {
        if (!cancelled) setOrders([]);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [analysisHash]);

  // Con el módulo activo la banda sale siempre: un plano sin pedidos es justo el que hay que presupuestar
  if (!loaded || !enabled) return null;

  const totalHours = orders.reduce((sum, order) => sum + (order.total_hours || 0), 0);
  const visible = open ? orders : orders.slice(0, MAX_VISIBLE);

  return (
    <div className="analysis-orders">
      <button
        className="analysis-orders-quote"
        onClick={() => navigate(`/offers/new?analysis=${analysisHash}`)}
        title="Abre la calculadora con este plano, para presupuestarlo"
      >
        Presupuestar este plano
      </button>
      {orders.length > 0 && (
      <button className="analysis-orders-toggle" onClick={() => setOpen(!open)}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <path d="M3 6h18M16 10a4 4 0 0 1-8 0" />
        </svg>
        {orders.length} pedido{orders.length === 1 ? '' : 's'} de este plano
        {totalHours > 0 && <span className="analysis-orders-hours">· {formatHours(totalHours)} en total</span>}
        <span className={`analysis-orders-caret ${open ? 'open' : ''}`}>›</span>
      </button>
      )}

      {open && (
        <ul className="analysis-orders-list">
          {visible.map((order) => (
            <li key={order.hash}>
              <button className="analysis-orders-item" onClick={() => navigate(`/orders/${order.hash}`)}>
                <span className="ao-client">{order.client?.name || 'Sin cliente'}</span>
                <span className="ao-ref">{order.client_reference || '—'}</span>
                <span className="ao-date">{formatDate(order.order_date)}</span>
                <span className="ao-hours">{formatHours(order.total_hours)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AnalysisOrders;
